import { render, staticRenderFns } from "./flowOutDetails.vue?vue&type=template&id=1a19cdb5&scoped=true"
import script from "./flowOutDetails.vue?vue&type=script&lang=js"
export * from "./flowOutDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a19cdb5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a19cdb5')) {
      api.createRecord('1a19cdb5', component.options)
    } else {
      api.reload('1a19cdb5', component.options)
    }
    module.hot.accept("./flowOutDetails.vue?vue&type=template&id=1a19cdb5&scoped=true", function () {
      api.rerender('1a19cdb5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/wovenBagManagement/detailManagement/cmp/flowOutDetails.vue"
export default component.exports